import { render } from "./SocialsIntegration.vue?vue&type=template&id=720ed790&scoped=true&ts=true"
import script from "./SocialsIntegration.vue?vue&type=script&lang=ts"
export * from "./SocialsIntegration.vue?vue&type=script&lang=ts"

import "./SocialsIntegration.vue?vue&type=style&index=0&id=720ed790&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720ed790"]])

export default __exports__